import styled from 'styled-components'
import {getStatusColor} from 'shared/utils/statusUtils'

const Style = {
	BadgesContainer: styled.div`
		display: flex;
		align-items: center;
		gap: 6px;
		flex-shrink: 0;
		width: fit-content;
	`,
	StatusBadge: styled.div.withConfig({
		shouldForwardProp: (prop) => prop !== 'statusColor',
	})`
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 4px 6px;
		background-color: ${({statusColor, theme}) =>
			getStatusColor(statusColor, theme)};
		border-radius: 99px;
		width: fit-content;
	`,

	StatusText: styled.span.withConfig({
		shouldForwardProp: (prop) => prop !== 'statusColor',
	})`
		${({theme}) => theme.font.tiny || theme.font.extra_small};
		color: ${({theme}) => theme.color.white || '#FFFFFF'};
		font-size: 8px;
		font-weight: 400;
		line-height: 1.2;
		text-align: center;
	`,
}

export default Style
